import { RSAA } from 'redux-api-middleware'
import resultHandle from './result'
import errorHandler from './error'
import headerHandler from './header'
import * as nprogress from 'nprogress'

const FAILURE = 'FAILURE'

// Preserve large numeric identifiers (e.g. 18-digit paymentOrderNo) that would lose precision
// if parsed as JS Number via res.json()/JSON.parse.
function coerceLargeNumericIdsToString(rawText) {
  if (!rawText || typeof rawText !== 'string') return rawText
  return rawText.replace(/("paymentOrderNo"\s*:\s*)(\d{16,})(\s*[,}])/g, '$1"$2"$3')
}

export default function callAPI({
  type = 'JSON',
  method = 'GET',
  endpoint,
  header,
  body,
  requestAction,
  successAction,
  success,
  error,
  dispatch,
  errControl,
  hideProgress,
}) {
  console.log('callAPI:body', JSON.stringify(body))
  const methods = headerHandler({
    type,
    method,
    endpoint,
    body,
    header,
  })
  return {
    [RSAA]: Object.assign({}, methods, {
      types: [
        {
          type: requestAction,
          payload: () => {
            !hideProgress && nprogress.start()
            return { isFetching: true }
          },
        },
        {
          type: successAction,
          payload: (action, state, res) => {
            !hideProgress && nprogress.done()
            return res
              .text()
              .then((text) => {
                const fixedText = coerceLargeNumericIdsToString(text)
                try {
                  return JSON.parse(fixedText)
                } catch (e) {
                  // Fallback for non-JSON responses
                  return {}
                }
              })
              .then((json) => {
                const result = resultHandle(
                  json,
                  success,
                  dispatch,
                  error,
                  errControl
                )
                return result
              })
          },
        },
        {
          type: FAILURE,
          payload: (action, state, res) => errorHandler(res),
        },
      ],
    }),
  }
}

export { default as syncSubmit } from './syncSubmit'
